import { EVENT } from "../config";

export const Footer = () => (
  <footer
    className="border-t border-[#DCD3C0] px-6 py-16 md:px-16"
    data-testid="footer"
  >
    <div className="mx-auto max-w-6xl">
      <div>
        <p className="font-display text-2xl font-light tracking-tight text-[#3F3A32]">
          {EVENT.name} {EVENT.age} years
        </p>
        <p className="mt-1 text-sm text-[#948B7B]">
          {EVENT.dateLabel} {EVENT.venue}
        </p>
      </div>
    </div>
  </footer>
);
